import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ReportConfigurationColumn } from 'app/infrastructure/model/interfaces/reportConfiguration.interface';
import { TypeOptions } from 'app/infrastructure/model/interfaces/rulePrototype.interface';
import { ReportConfigurationService } from 'app/infrastructure/services/reportConfiguration.service';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';


@Component({
    selector: 'sx-mappingList-reportconfiguration',
    templateUrl: './mappingList.reportconfiguration.component.html',
})
export class MappingListReportConfigurationComponent implements OnInit {
    systemCode: string;
    businessCode: string;
    reportCode: string;
    preguntarSiDeseaBorrar = [];
    mappingColumns: ReportConfigurationColumn[] = [];

    // Opciones Tipo Dato
    opciones = TypeOptions;
    
    constructor(
        private aRoute: ActivatedRoute,
        private _router: Router,
        private reportService: ReportConfigurationService,
        private location: Location,
        private alertService: AlertService,
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.systemCode = params['codsistema'];
            this.businessCode = params['codnegocio'];
            this.reportCode =  params['codreporte'];
                this.reportService.getReportColumns(this.reportCode).
                    subscribe(data => {
                        if (!data) {
                            return this._router.navigateByUrl('/soc/404');
                        }
                        if (data !== undefined) {
                            this.mappingColumns = data;
                        }
                    });
            }
        );
    }

    clickEdit(attribute) {
        this._router.navigate(['./', attribute.id], { relativeTo: this.aRoute });
    }

    deleteColumn(attribute: ReportConfigurationColumn) {
        this.reportService.deleteColumn(attribute).
        then(x => {
            if(x){
                this.alertService.showGrowl({
                    type: GrowlType.SUCCESS,
                    body: 'OUTPUT_ATTRIUBUTE_DELETE_SUCCESS',
                });
            }
        });
    }

    createNew() {
        this._router.navigate(['./', 'new'], { relativeTo: this.aRoute });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/reportConfiguration/mapping/mappingList.reportconfiguration.component.ts